import { SecondaryPageLink } from '@/PageManager'
import { generateBech32IdFromATag, tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'

export default function GeocacheCurationList({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const title = useMemo(() => event.tags.find(tagNameEquals('title'))?.[1], [event])
  const dTag = useMemo(() => event.tags.find(tagNameEquals('d'))?.[1], [event])
  const description = useMemo(() => event.tags.find(tagNameEquals('description'))?.[1], [event])
  const image = useMemo(() => event.tags.find(tagNameEquals('image'))?.[1], [event])
  const theme = useMemo(() => event.tags.find(tagNameEquals('theme'))?.[1], [event])
  const map = useMemo(() => event.tags.find(tagNameEquals('map'))?.[1], [event])
  const cacheRefs = useMemo(
    () =>
      event.tags
        .filter((t) => t[0] === 'a' && t[1].startsWith('37516:'))
        .map((t) => ({ coordinate: t[1], naddr: generateBech32IdFromATag(t) }))
        .filter((r) => r.naddr),
    [event]
  )

  return (
    <div className={cn('space-y-2', className)}>
      <div className="font-medium">Geocache curation list</div>
      <div className="text-xl font-semibold line-clamp-1">{title || dTag}</div>
      {image && (
        <img
          src={image}
          alt={title || dTag}
          className="w-full aspect-[3/1] object-cover rounded-lg"
        />
      )}
      {description && (
        <div className="text-sm text-muted-foreground line-clamp-4">{description}</div>
      )}
      {event.content && (
        <div className="prose prose-zinc max-w-none dark:prose-invert break-words text-sm">
          {event.content}
        </div>
      )}
      <div className="space-y-1 text-sm text-muted-foreground">
        {theme && (
          <div>
            <span className="font-medium text-foreground">Theme: </span>
            {theme}
          </div>
        )}
        {map && (
          <div>
            <span className="font-medium text-foreground">Map: </span>
            {map}
          </div>
        )}
      </div>
      {cacheRefs.length > 0 && (
        <div className="space-y-1">
          <div className="font-medium text-sm text-foreground">Caches ({cacheRefs.length}):</div>
          {cacheRefs.map((r, i) => {
            const identifier = r.coordinate.split(':')[2]
            return (
              <SecondaryPageLink
                key={i}
                to={`/${r.naddr}`}
                className="block text-primary hover:underline text-sm truncate"
                onClick={(e) => e.stopPropagation()}
              >
                {i + 1}. {identifier || r.naddr}
              </SecondaryPageLink>
            )
          })}
        </div>
      )}
    </div>
  )
}
